var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Content',{staticClass:"page-content"},[_c('AdminNav',{staticClass:"nav"}),_c('Card',{staticClass:"content-wrapper"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }